import React from 'react';
import './iconnav-footer.css'

const Iconnavfooter = (props) => {
    return ( 
        <li className='nav-icon-text-footer'>
            <img src={props.imgg} alt='icon'></img>
            <h3 className='text-icon-footer'>{props.title}</h3>
        </li>
     );
}
 
export default Iconnavfooter;